/** Navega na mesma aba: o app do WhatsApp abre e, na volta, a pessoa está de novo no /clube. */
export function openWhatsapp(url: string) {
  window.location.assign(url);
}
